import { isAlphanumeric } from "@pineapplelab/util";
import { Core } from "../../core/core";
/**
 * The value must have only alphanumeric characters.
 *
 * Example:
 * ````
 * *@IsAlphanumeric() firstName = null;
 * *@IsAlphanumeric({ allowEmpty: true, allowedCharacters: '-_' }) username = null;
 * ````
*/
export function IsAlphanumeric(options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        var message = "The field: '" + (options.label ? options.label : propertyKey) + "' must have only alphanumeric characters";
        Core.setFieldValidator(target, propertyKey, {
            name: 'IsAlphanumeric',
            isValid: function (o, f) { return isAlphanumeric(o[f], options.allowedCharacters, options.allowEmpty); },
            message: options.message ? options.message : message
        });
    };
}
;
